export default "__VITE_ASSET__BpFX1lCO__"